// Packages:
import Home from "./pages/home"
import Details from "./pages/details"
import { ToastContainer } from 'react-toastify'
import { createBrowserRouter, RouterProvider } from "react-router-dom"
import NotFound from "./pages/notFound"

// Styles:
import 'swiper/css'
import 'swiper/css/pagination'

// Toastify Styles
import 'react-toastify/dist/ReactToastify.css'

function App() {
  // Constants:
  const router = createBrowserRouter([
    {
      path: '/',
      errorElement: <NotFound/>,
      children: [
        {
          path: '/',
          element: <Home />,
        },
        {
          path: '/details/:courseId',
          element: <Details />,
        }
      ]
    }
    // {
    //   path: '*',
    //   element: <NotFound/>
    // }
  ])
  return (<>
    <ToastContainer 
      position="top-center"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
    />
    <div className='font-nunito grid grid-cols-[20px_minmax(200px_,_auto)_20px] lg:grid-cols-[1fr_1024px_1fr] xl:grid-cols-[1fr_1240px_1fr] 2xl:grid-cols-[1fr_1450px_1fr]'>
      <RouterProvider router={router}/>
    </div>
  </>
    
  );
}

export default App;
